module.exports = __webpack_public_path__ + "static/media/rolik.5f447460.png";